/* eslint-disable no-console */
/* eslint-disable i18next/no-literal-string */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getRecaptchaConfig, IRecaptchaConfiguration } from '../configuration/configuration';
import { updateRecaptchaEnabled } from '../Store/Actions';

const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-enterprise';

export const Recaptcha: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const config: IRecaptchaConfiguration = getRecaptchaConfig();
    const existingScript = document.querySelector(`#${RECAPTCHA_SCRIPT_ID}`);

    if (!existingScript) {
      // Inject the Google reCAPTCHA script only once. React StrictMode can run
      // effects more than once during development.
      const script = document.createElement('script');
      script.id = RECAPTCHA_SCRIPT_ID;
      script.src = `${config.enterpriseScriptUrl}?render=${config.renderKey}`;
      script.async = true;
      script.defer = true;
      document.head.append(script);
    }

    dispatch(updateRecaptchaEnabled(true));
  }, [dispatch]);

  return <></>;
};
